import isEmail from 'validator/es/lib/isEmail';

class Validator {
    email = (value: string) => isEmail(value);

    required = (value: string | null | undefined): value is RequiredResult => {
        if (value === null || value === undefined || value.toString().trim() === '') {
            return false;
        }
        value satisfies RequiredResult;
        ({}) as RequiredResult satisfies typeof value;

        return true;
    };

    minLength = (value: string | undefined, minLength: number) => {
        if (value && value.length >= minLength) {
            return true;
        }
        return false;
    };

    maxLength = (value: string, maxLength: number) => {
        if (value.length <= maxLength) {
            return true;
        }
        return false;
    };

    match = (value1: string, value2: string) => {
        if (value1 === value2) {
            return true;
        }
        return false;
    };

    number = (value: string) => {
        const regex = /^\d+$/;
        return regex.test(value);
    };

    validPassword = (value: string) => {
        const regex =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[=+\-\^$*.\[\]{}()?"!@#%&/\\,><':;|_~`])[A-Za-z\d=+\-\^$*.\[\]{}()?"!@#%&/\\,><':;|_~`]{8,}$/; /* eslint-disable-line no-useless-escape */ // INSPECT: I don't dare touch this regex with "useless escape" errors
        return regex.test(value);
    };

    vaildName = (value: string) => {
        // Having a ' or " in the name breaks the token when it gets submitted to cloudfront
        // When JSON.parse'ing the token it breaks at these characters
        const regex = /^((?!['"]).)*$/;
        return regex.test(value);
    };

    alphanumeric = (value: string) => {
        const letters = /^[0-9a-zA-Z]+$/;
        if (value.match(letters)) {
            return true;
        }
        return false;
    };
}

type RequiredResult = string;

export default Validator;
